import { Provider } from "@angular/core";
import { PasoCargaCache } from "./PasoCargaCache";
import { PasoFiltrado } from "./PasoFiltrado";
import { PasoObtenerRespuestas } from "./PasoObtenerRespuestas";
import { ObtenerRespuestasSinComparativa } from "./ObtenerRespuestasSinComparativa";

export const PasosProviders: Provider[] = [
    PasoCargaCache,
    PasoFiltrado,
    PasoObtenerRespuestas,
    ObtenerRespuestasSinComparativa
];
